import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static targets = ['customBadgeName']

  toggleCustomBadgeName(event) {
    const customBadgeValue = event.target.dataset.customBadgeValue;
    if (customBadgeValue === "true") {
      this.customBadgeNameTarget.classList.remove('hidden');
    } else {
      this.customBadgeNameTarget.classList.add('hidden');
    }
  }
}
